import { LAB_COLOR_BY_ID, type LabColor } from "../colors/palette.ts";

/**
 * Marble colours of the Logic Tower. They borrow the Color Lab essences and
 * their GPT marks, so a colour looks and reads the same in every house and
 * never depends on hue alone.
 */
export const TOWER_MARBLE_IDS = ["ruby", "sky", "honey", "jade"] as const;

export const TOWER_MARBLES: readonly LabColor[] = TOWER_MARBLE_IDS.map((id) => LAB_COLOR_BY_ID.get(id) as LabColor);

export const TOWER_MARBLE_BY_ID: ReadonlyMap<string, LabColor> = new Map(TOWER_MARBLES.map((color) => [color.id, color]));

/** Art the Logic Tower scene needs besides the colour marks. */
export const TOWER_ASSET_IDS = [
  "tower.lever",
  "tower.ramp",
  "tower.peg",
  "tower.marble",
  "tower.gear",
  "tower.lid",
  "tower.gutter",
  "tower.bell",
  "tower.tube",
  "tower.rail",
  "tower.funnel",
  "tower.pipe",
  "tower.cradle",
  "tower.crest",
  "tower.shelf",
  "tower.glow",
  "reward.sparkle",
] as const;
